<template>
<div :ref="loadingobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑续费设置</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="renewlist.length > 1 ? renewlist.length : ''" class="item">
        <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'返回设置管理',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsRenew'})"/>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in renewlist" :key="index">
            <div class="TTL-form-submit-box-title">设置-{{index+1}}</div>
            <el-form :inline="false" style="margin-top:20px">
                <el-form-item>
                    <label class="TTL-form-label">设置名称<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入设置名称',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.name"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.name=val.value;
                            }
                            if(val.type=='change') {
                                item.name=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">设置金额<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入设置金额',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.price"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.price=val.value;
                            }
                            if(val.type=='change') {
                                item.price=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">作用区域<i>*</i></label>
                    <wcselect :option="{placeholder:'请选择作用区域',multiple:true,filterable:true,ischange:true}" 
                        :value="item.area_type" 
                        :list="areatype"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.area_type=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">置顶时间<i>*</i></label>
                    <wcinputprex 
                        :value="item.nums" 
                        :option="{placeholder:'置顶时间',childtype:'select',width:'200px',isinput:true}"
                        :svalue="item.timetype"
                        :slist="timetype"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.nums=val.value;
                            }
                            if(val.type=='change') {
                                item.timetype=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">备注</label>
                    <wcinput :option="{placeholder:'请输入设置备注',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.note"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.note=val.value;
                            }
                            if(val.type=='change') {
                                item.note=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">推广标签</label>
                    <wcinput :option="{placeholder:'请输入标签',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.label"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.label=val.value;
                            }
                            if(val.type=='change') {
                                item.label=val.value;
                            }
                        }"
                    />
                </el-form-item>
                
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_RENEW from '@/Interface/Es/Renew';
export default {
    components:{},
    data() {
        return {
            Browser:'editrenew',
            loadingobj:'editrenew',
            limit:10,  //限制添加数据条数
            memberinfo:{name:'',area_type:[],timetype:1,nums:'',price:'',note:''}, //设置模板信息           
            renewlist:[], //续费设置
            timetype:[], //时间类型
            areatype:[], //置顶作用区域

            typelist:[
                {id:1,name:'充值条数'},
                {id:2,name:'充值可发布时间'}
            ],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetRenewTimeType(isfresh); //获取设置时间类型
            this.GetRenewAreaType(isfresh); //获取置顶作用区域
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前有操作正在执行，是否要将其覆盖 ？',
                    '删除提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
                ).then(()=> {
                    this.GetRenewInfo(data.param.id);
                }).catch(()=> {

                });
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetRenewInfo(data.param.id);
            }
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.renewlist.length==0) {this.$notice({title:'错误提示',message:'请至少填写一个设置',type:'warning'});return false;}
            var data=[];
            for(var i in this.renewlist) data.push(this.renewlist[i]);
            data=JSON.stringify(data);

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_RENEW.EDIT_RENEW({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.$notice({title:'成功提示',message:'添加数据成功',type:'success'});
                this.$parent.JUMPVIEW({name:'EsRenew',delname:'EsEditRenew'});
            });
        },


        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作


        /** 获取续费设置信息 **/
        GetRenewInfo(id) {
            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_RENEW.GET_RENEW_INFO({ids:id}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.renewlist=res.data;
                console.log(res.data);
            });
        },


        /** 获取会员类型信息 **/
        GetRenewTimeType(isfresh) {
            this.$method.GET_RENEW_TIME_TYPE(isfresh).then((res) => {this.timetype=res;console.log(res)});
        },

        /** 获取作用区域类型信息 **/
        GetRenewAreaType(isfresh) {
            this.$method.GET_RENEW_AREA_TYPE(isfresh).then((res) => {this.areatype=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
</style>